import { get, isMockMode, simulateDelay } from "../api";
import { setSingleLicenceState } from "./getForUser";

export const getLicenceDetails = ({ licenceId }: { licenceId: string }) => {
	if (isMockMode()) {
		const testData = {
			assignedToUser: {
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				email: "test.mctestie@mgaol.abc",
				firstName: null,
				lastName: null,
			},
			assignedByUser: {
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				email: "test.mctestie@mgaol.abc",
				firstName: "Test",
				lastName: "McTestie",
			},
			subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
			id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
			activeMachine: null,
			finalExpirationUtc: "2033-02-28T02:15:04.7550000Z",
			licenceExpirationUtc: "2033-02-28T02:15:04.7550000Z",
			lastUsedUtc: null,
			lastActivatedUtc: null,
			isRevoked: false,
		};

		return simulateDelay(50, () => setSingleLicenceState(testData));
	}

	return get(`licences/getdetails?licenceid=${licenceId}`).then(
		setSingleLicenceState
	);
};
